import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface UiStore {
  isSidebarOpen: boolean;
  isPollDrawerOpen: boolean;
  docId: string | number | null;
  openSidebar: () => void;
  closeSidebar: () => void;
  toggleSidebar: () => void;
  openPollDrawer: (docId?: string | number | null) => void;
  closePollDrawer: () => void;
}

export const useUiStore = create<UiStore>()(
  devtools(
    (set) => ({
      isSidebarOpen: false,
      isPollDrawerOpen: false,
      docId: null,

      openSidebar: () =>
        set({ isSidebarOpen: true }, false, "ui/openSidebar"),
      closeSidebar: () =>
        set({ isSidebarOpen: false }, false, "ui/closeSidebar"),
      toggleSidebar: () =>
        set(
          (state) => ({ isSidebarOpen: !state.isSidebarOpen }),
          false,
          "ui/toggleSidebar",
        ),
      openPollDrawer: (docId = null) =>
        set(
          { isPollDrawerOpen: true, docId },
          false,
          "ui/openPollDrawer",
        ),
      closePollDrawer: () =>
        set(
          { isPollDrawerOpen: false, docId: null },
          false,
          "ui/closePollDrawer",
        ),
    }),
    { name: "UiStore" },
  ),
);
